module.exports = __webpack_public_path__ + "static/media/Raaz-Img3.31221d96.png";